
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Container from "@/components/container";
import DocumentTitle from "@/components/document-title/DocumentTitle";
import LinkToLogin from "@/components/link-to-login/LinkToLogin";
import { Typography } from "antd";
import Trans from "next-translate/Trans";
import useTranslation from "next-translate/useTranslation";
function CookiePolicy() {
    const { t } = useTranslation("cookie-policy");
    return (<>
      <DocumentTitle title={t("title")}/>

      <LinkToLogin />

      <Container>
        <Typography.Title level={3}>{t("doc-title")}</Typography.Title>
        <Typography.Title level={3}>{t("sub-doc-title")}</Typography.Title>
        <Typography.Paragraph>{t("p1")}</Typography.Paragraph>
        <Typography.Paragraph>{t("p2")}</Typography.Paragraph>
        <Typography.Paragraph>{t("p3")}</Typography.Paragraph>
        <Typography.Paragraph>{t("p4")}</Typography.Paragraph>
        <Typography.Paragraph>{t("p5")}</Typography.Paragraph>
        <Typography.Paragraph>{t("p6")}</Typography.Paragraph>
        <Trans i18nKey="cookie-policy:p7" components={[
            <Typography.Paragraph key={0}/>,
            <a key={1} href="http://www.garanteprivacy.it/cookie" target="_blank" rel="noreferrer"/>,
        ]}/>
        <Typography.Title level={4}>{t("h-3")}</Typography.Title>
        <Typography.Paragraph>{t("p8")}</Typography.Paragraph>
        <Typography.Paragraph>{t("p9")}</Typography.Paragraph>
        <ul>
          <li>
            <Typography.Paragraph>{t("li1")}</Typography.Paragraph>
          </li>
          <li>
            <Typography.Paragraph>{t("li2")}</Typography.Paragraph>
          </li>
          <li>
            <Typography.Paragraph>{t("li3")}</Typography.Paragraph>
          </li>
          <li>
            <Typography.Paragraph>{t("li4")}</Typography.Paragraph>
          </li>
          <li>
            <Typography.Paragraph>{t("li5")}</Typography.Paragraph>
          </li>
          <li>
            <Typography.Paragraph>{t("li6")}</Typography.Paragraph>
          </li>
        </ul>
        <Typography.Paragraph>{t("p10")}</Typography.Paragraph>
        <Typography.Paragraph>{t("p11")}</Typography.Paragraph>
        <ul>
          <li>
            <Typography.Paragraph>{t("li7")}</Typography.Paragraph>
          </li>
          <li>
            <Typography.Paragraph>{t("li8")}</Typography.Paragraph>
          </li>
        </ul>
      </Container>
    </>);
}
export default CookiePolicy;

    async function __Next_Translate__getStaticProps__18fe7779627__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cookie-policy/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18fe7779627__ as getStaticProps }
  